/**
 * Canonical QuickBooks document numbers for matching Megaventory rows.
 */

export type QboPurchaseDocClass = "gipi" | "tsh" | "sbo" | "wofg" | "other";

export function toKey(value: string): string {
  return value.trim().toUpperCase();
}

export function toCanonicalPurchaseDocNumber(value: string): string | null {
  const keyed = toKey(value);
  const gipiTsh = /\b(GIPI|TSH)\s*-?\s*(\d+)\b/.exec(keyed);
  if (gipiTsh) {
    const numberPart = Number.parseInt(gipiTsh[2], 10);
    if (Number.isFinite(numberPart)) {
      return `${gipiTsh[1]} ${numberPart}`;
    }
  }
  const sbo = /\bSBO\b[\s-]*([A-Z0-9-]+)/i.exec(value);
  if (sbo) {
    return toKey(sbo[0].replace(/\s+/g, " "));
  }
  const wofg = /\bWOFG\s*-?\s*(\d+)\b/i.exec(keyed);
  if (wofg) {
    const numberPart = Number.parseInt(wofg[1], 10);
    if (Number.isFinite(numberPart)) {
      return `WOFG ${numberPart}`;
    }
  }
  return null;
}

export function classifyPurchaseDocNumber(value: string): QboPurchaseDocClass {
  const keyed = toKey(value);
  if (/\bGIPI\s*-?\s*\d+\b/.test(keyed)) return "gipi";
  if (/\bTSH\s*-?\s*\d+\b/.test(keyed)) return "tsh";
  if (/\bSBO\b/.test(keyed)) return "sbo";
  if (/\bWOFG\s*-?\s*\d+\b/.test(keyed)) return "wofg";
  return "other";
}

export function toCanonicalSalesDocNumber(value: string): string | null {
  const keyed = toKey(value);
  const gosi = /\bGOSI\s*-?\s*(\d+)\b/.exec(keyed);
  if (!gosi) {
    return null;
  }
  const numberPart = Number.parseInt(gosi[1], 10);
  if (!Number.isFinite(numberPart)) {
    return null;
  }
  return `GOSI ${numberPart}`;
}

export function toQboSalesDocNumberFromInvoiceNumber(invoiceNumber: string): string {
  return `GOSI ${invoiceNumber.trim()}`;
}
